import React from 'react';
import { useEffect, useState } from "react";

const VechilesSearchPage = ({data, item, handleData}) => {
  const [toggleSave, setToggleSave] = useState([])
  const [currentItem, setCurrentItem] = useState('');
  const [currentItemTotals, setCurrentItemTotals] = useState('1');
  const [itemDays, setItemDays] = useState('');
  
  const Totals = (itemData) => {
    let numOfOrders = 0 
    let employerMoney = 0
    let employerInputPrice = 0
    let petrol = 0;
    let oil = 0;
    let repairs = 0;

    for (let x of itemData) {
      for (let y of x.rounds) {
         numOfOrders += Number(y.numOfOrders )
         employerMoney += Number(y.employerMoney)
         employerInputPrice += Number(y.employerInputPrice)
      }
      petrol += Number(x.expenses.petrol)
      oil += Number(x.expenses.oil)
      repairs += Number(x.expenses.repairs)
    }
    setCurrentItemTotals({
      numOfOrders,
      employerMoney,
      employerInputPrice,
      petrol,
      oil,
      repairs
    })
  }

  useEffect(() => {
    const newData = JSON.parse(JSON.stringify(data));
    setCurrentItem(newData[item])
    setItemDays(newData[item].days)
    Totals(newData[item].days)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleSearch = () => {
    const fromValue = document.getElementById('from').value;
    const toValue = document.getElementById('to').value;

    if (fromValue && toValue) {
      let startDate = new Date(fromValue).toLocaleDateString() ;
      let endDate = new Date(toValue).toLocaleDateString() ;
      // Compare x to the start and end dates
      let newItemDays = [...currentItem.days].filter((r) => (
         new Date(r.date).toLocaleDateString()  >= startDate && new Date(r.date).toLocaleDateString()  <= endDate
      ))

      setItemDays(newItemDays)
      Totals(newItemDays)

    }
  }
  const handlePriceChange = (dayID) => {
    let petrolValues = document.getElementById('petrol'+dayID).value
    let oilValues = document.getElementById('oil'+dayID).value
    let repairsValues = document.getElementById('repairs'+dayID).value

    if (petrolValues >= 0 && oilValues >= 0 && repairsValues >= 0 && petrolValues && oilValues && repairsValues) {
      let newToggleSave = [...toggleSave];
      newToggleSave.push(dayID)
      setToggleSave(newToggleSave)
    }else {
      let newToggleSave = [...toggleSave].filter((x) => x !== dayID)
      setToggleSave(newToggleSave)
    }
  }
  const handleSave = (dayID) => {
    let petrolValues = document.getElementById('petrol'+dayID).value
    let oilValues = document.getElementById('oil'+dayID).value
    let repairsValues = document.getElementById('repairs'+dayID).value

    handleData({petrolValues, oilValues, repairsValues}, dayID, currentItem.vehicle.id)
    let newToggleSave = [...toggleSave].filter((x) => x !== dayID)
    setToggleSave(newToggleSave)
  }
  return (
    <section>
      <section className="search-bar">
        <p>Search From :-</p>
        <input type='date' id="from" />
        <p>To</p>
        <input type='date' id="to" />
        <button onClick={() => handleSearch()}>OK</button>
      </section>
      <br />
      <section className="table-data">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Employee</th>
              <th>Started At</th>
              <th>Working Hours</th>
              <th>Orders</th>
              <th>Money income $</th>
              <th>Salaries $</th>
              <th>Petrol $</th>
              <th>Oil $</th>
              <th>Repairs $</th>
              <th></th>
            </tr>
          </thead>
          {currentItem && 
            <tbody>
              {
                itemDays.map((day) => (
                  day.rounds.map((x, i) => (
                    <tr key={x.roundID}>
                      {i === 0 && <td rowSpan={day.rounds.length}>{new Date(day.date).toDateString()}</td>}
                      <td>{x.employer.name}</td>
                      <td>{x.startedAt.join(' : ')}</td>
                      <td>{x.workingHours}</td>
                      <td>{x.numOfOrders}</td>
                      <td>{x.employerInputPrice} $</td>
                      <td>{x.employerMoney} $</td>
                      {i === 0 && 
                        <>
                          <td rowSpan={day.rounds.length}>
                            <input 
                              type='number'
                              defaultValue={day.expenses.petrol} 
                              id={'petrol'+day.id}
                              onChange={(e) => handlePriceChange(day.id)}
                              min='0'
                            /> 
                          </td>
                          <td rowSpan={day.rounds.length}>
                            <input 
                              type='number'
                              defaultValue={day.expenses.oil} 
                              id={'oil'+day.id}
                              onChange={(e) => handlePriceChange( day.id)}
                              min='0'
                              /> 
                          </td>
                          <td rowSpan={day.rounds.length}>
                            <input 
                              type='number'
                              defaultValue={day.expenses.repairs} 
                              id={'repairs'+day.id}
                              onChange={(e) => handlePriceChange(day.id)}
                              min='0'
                              /> 
                          </td>
                          <td rowSpan={day.rounds.length}>
                          {toggleSave.includes(day.id) && 
                            <button onClick={() => handleSave(day.id)}>Save</button>
                          }
                          </td>
                        </>
                      }
                    </tr>
                  ))
                ))
              }
            </tbody>
          }
          
          {currentItemTotals && 
            <tfoot>
              <tr>
                <td>- - -</td>
                <td>- - -</td>
                <td>- - -</td>
                <td>- - -</td>
                <td>{currentItemTotals.numOfOrders}</td>
                <td>{currentItemTotals.employerInputPrice} $</td>
                <td>{currentItemTotals.employerMoney} $</td>
                <td>{currentItemTotals.petrol} $</td>
                <td>{currentItemTotals.oil} $</td>
                <td>{currentItemTotals.repairs} $</td>
                <td>- - -</td>
              </tr>
            </tfoot>
            }
          
        </table>
      </section>
    </section>
  )
}

export default VechilesSearchPage;